<template>
  <section class="hero-news" @mouseenter="stopAutoSlide" @mouseleave="startAutoSlide">
    <div class="hero-main" v-if="current">
      <!-- عکس خبر — در RTL سمت راست می‌نشیند -->
      <div class="hero-media">
        <transition name="hero-fade">
          <img
              :key="current.id"
              :src="current.imageUrl || 'https://picsum.photos/900/500'"
              alt=""
              @click="goToNews(current)"
          />
        </transition>
        <!-- دکمه‌های ناوبری — راست=قبلی (محتوا به راست می‌رود)، چپ=بعدی (محتوا به چپ می‌رود) -->
        <div class="slider-controls" v-if="news.length > 1">
          <button @click="nextSlide" class="slider-btn" aria-label="خبر قبلی">‹</button>
          <button @click="prevSlide" class="slider-btn" aria-label="خبر بعدی">›</button>
        </div>
        <!-- شمارهٔ اسلایدها ۱ تا ۱۰ -->
        <div class="hero-nums" v-if="news.length > 1">
          <button
              v-for="(item, i) in news"
              :key="'n-' + item.id"
              :class="['hero-num', {active: i === currentIndex}]"
              @click="goToSlide(i)"
              :aria-label="'خبر ' + (i + 1)"
          >{{ i + 1 }}</button>
        </div>
      </div>
      <!-- متن خبر — در RTL سمت چپ می‌نشیند -->
      <div class="hero-text">
        <span class="hero-badge">{{ current.source?.name || 'خبرگزاری' }}</span>
        <h1 class="hero-title" @click="goToNews(current)">{{ current.title }}</h1>
        <p class="hero-summary" v-if="current.summary">{{ current.summary }}</p>
        <div class="hero-meta">
          <span class="hero-time">{{
              current.publishedAt ? timeAgo(current.publishedAt) : 'همین الان'
            }}</span>
        </div>
      </div>
    </div>
    <!-- حالت لودینگ/خالی -->
    <div class="hero-main hero-placeholder" v-else>
      <div class="hero-media">
        <img src="https://picsum.photos/900/500" alt=""/>
      </div>
      <div class="hero-text">
        <h1 class="hero-title">جدیدترین خبر ورزشی</h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroNews',
  data() {
    return {
      news: [],
      loading: false,
      currentIndex: 0,
      slideInterval: null,
    };
  },
  computed: {
    // خبر فعلی اسلایدر
    current() {
      return this.news[this.currentIndex] || null;
    },
  },
  async mounted() {
    await this.fetchHeroNews();
    this.startAutoSlide();
  },
  beforeDestroy() {
    this.stopAutoSlide();
  },
  methods: {
    async fetchHeroNews() {
      try {
        this.loading = true;
        // ۱۰ خبر آخر برای اسلایدر
        const res = await fetch('/api/news?limit=10');
        const data = await res.json();
        this.news = data.news || [];
        // محافظت: اگر ایندکس از تعداد خبرها بیشتر شد ریست شود
        if (this.currentIndex >= this.news.length) this.currentIndex = 0;
      } catch (err) {
        console.error('HeroNews fetch error:', err);
      } finally {
        this.loading = false;
      }
    },
    timeAgo(dateStr) {
      if (!dateStr) return '';
      const now = new Date();
      const date = new Date(dateStr);
      const diff = Math.floor((now - date) / 1000);
      if (diff < 60) return 'همین الان';
      if (diff < 3600) return `${Math.floor(diff / 60)} دقیقه پیش`;
      if (diff < 86400) return `${Math.floor(diff / 3600)} ساعت پیش`;
      return `${Math.floor(diff / 86400)} روز پیش`;
    },
    goToNews(item) {
      if (!item) return;
      this.$router.push({
        name: 'NewsDetail',
        params: {slug: item.id + '-' + this.slugify(item.title)},
      });
    },
    slugify(title) {
      if (!title) return '';
      return title
          .trim()
          .replace(/\u200c|\u200b|\u200d|\ufeff/g, '-')
          .replace(/[,;:.!?"'()]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
    },
    nextSlide() {
      if (this.news.length === 0) return;
      this.currentIndex = (this.currentIndex + 1) % this.news.length;
    },
    // رفتن به خبر قبلی
    prevSlide() {
      if (this.news.length === 0) return;
      this.currentIndex = (this.currentIndex - 1 + this.news.length) % this.news.length;
    },
    // رفتن به خبر خاص (با کلیک روی شماره‌ها)
    goToSlide(index) {
      this.currentIndex = index;
    },
    // شروع اسلایدر خودکار
    startAutoSlide() {
      if (this.slideInterval) clearInterval(this.slideInterval);
      this.slideInterval = setInterval(() => {
        this.nextSlide();
      }, 8000); // هر ۸ ثانیه
    },
    // توقف اسلایدر (وقتی موس روی هیرو است)
    stopAutoSlide() {
      if (this.slideInterval) {
        clearInterval(this.slideInterval);
        this.slideInterval = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/sass/variables';
@import '@/assets/sass/mixin';

.hero-news {
  display: block;
}

/* کارت افقی: عکس + متن کنار هم — عرض ستون‌ها ثابت تا با تغییر خبر تکون نخورد */
.hero-main {
  display: flex;
  align-items: stretch;
  height: 290px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: $shadow-sm;
}

/* ===== سمت عکس (راست در RTL) =====
   تصویر absolute داخل قاب ثابت — هیچ‌وقت قاب خالی نمی‌ماند و layout نمی‌پرد */
.hero-media {
  flex: 0 0 44%;
  min-width: 0;
  position: relative;
  overflow: hidden;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    cursor: pointer;
  }
}

.slider-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  pointer-events: none;
  z-index: 2;
}

.slider-btn {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.45);
  border: none;
  color: #fff;
  font-size: 1.5rem;
  line-height: 1;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-btn:hover {
  background: rgba(16, 185, 129, 0.85);
}

/* شمارهٔ اسلایدها ۱ تا ۱۰ — گوشهٔ پایین عکس */
.hero-nums {
  position: absolute;
  bottom: 8px;
  left: 10px;
  flex-direction: row-reverse;
  inset-inline-start: 10px;
  display: flex;
  gap: 4px;
  z-index: 2;
}

.hero-num {
  width: 23px;
  height: 23px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-family: inherit;
  font-size: 0.7rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.85);
  }

  &.active {
    background: #10b981;
    color: #fff;
    font-weight: 800;
  }
}

/* ===== سمت متن (چپ در RTL) ===== */
.hero-text {
  flex: 0 0 56%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 14px 20px;
  background-color: #f3f3f3;
}

.hero-badge {
  width: max-content;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #047857, #10b981);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.hero-title {
  cursor: pointer;
  margin: 0 0 6px 0;
  font-size: 1.3rem;
  font-weight: 800;
  line-height: 1.45;
  color: $gray-900;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color $transition-time;

  &:hover {
    color: #059669;
  }
}

.hero-summary {
  margin: 0 0 10px 0;
  color: $gray-500;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hero-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: auto;
}

.hero-time {
  color: $gray-400;
  font-size: 0.8rem;
  white-space: nowrap;
}

/* ترنزیشن محو بین اسلایدها (crossfade — تصویر قدیمی و جدید روی هم) */
.hero-fade-enter-active,
.hero-fade-leave-active {
  transition: opacity 0.35s ease;
}

.hero-fade-enter-from,
.hero-fade-leave-to {
  opacity: 0;
}

/* ===== تبلت ===== */
@include tablet {
  .hero-main {
    height: 240px;
  }

  .hero-title {
    font-size: 1.2rem;
  }
}

/* ===== موبایل: عکس بالا، متن زیر ===== */
@include mobile {
  .hero-main {
    flex-direction: column; /* عکس اول DOM است → بالا */
    height: auto;
    border-radius: 0;
    border-inline: none;
  }

  .hero-media {
    flex: none;
    height: 200px;
  }

  .hero-text {
    padding: 14px 16px 16px;
  }

  .hero-title {
    font-size: 1.05rem;
    -webkit-line-clamp: 3;
  }

  .hero-summary {
    font-size: 0.85rem;
  }

  .slider-btn {
    width: 34px;
    height: 34px;
    font-size: 1.3rem;
  }

  .hero-num {
    width: 22px;
    height: 22px;
    font-size: 0.65rem;
  }

  .hero-nums {
    gap: 4px;
    bottom: 8px;
    inset-inline-start: 10px;
  }
}
</style>
